import { useTranslation } from 'react-i18next';
import { Languages } from 'lucide-react';
import { LANGUAGE_OPTIONS, setLanguage } from '@/i18n';
import type { SupportedLanguage } from '@/i18n';

/** Compact language select for the header; the choice is persisted in localStorage. */
export function LanguageSwitcher() {
  const { t, i18n } = useTranslation();
  const current = (LANGUAGE_OPTIONS.find(o => o.code === i18n.language)?.code ?? 'en') as SupportedLanguage;

  return (
    <label className="flex items-center gap-1 text-text-tertiary" title={t('web:header.language')}>
      <Languages className="h-4 w-4" />
      <select
        value={current}
        onChange={e => { void setLanguage(e.target.value as SupportedLanguage); }}
        aria-label={t('web:header.language')}
        className="max-w-[9rem] cursor-pointer rounded-md border border-border-secondary bg-surface-primary px-2 py-1 text-xs text-text-secondary focus:border-brand-500 focus:outline-none"
      >
        {LANGUAGE_OPTIONS.map(option => (
          <option key={option.code} value={option.code}>{option.label}</option>
        ))}
      </select>
    </label>
  );
}
